import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { mergeMap } from 'rxjs/operators'

import { combineEpicsIsolated } from 'utils/epicRegistry'

import { addToast } from 'containers/Toasts/actions'

import { SUBMIT_ENCRYPTION_DEMO_REQUEST } from './constants'

const submitEncryptionDemoEpic = (action$) =>
  action$.pipe(
    ofType(SUBMIT_ENCRYPTION_DEMO_REQUEST.INITIATE),
    mergeMap(() =>
      of(
        SUBMIT_ENCRYPTION_DEMO_REQUEST.onSuccess(),
        addToast({
          message:
            'Your demo request has been successfully submitted. Our team will reach out to you shortly.',
          type: 'success',
        })
      )
    )
  )

export default combineEpicsIsolated(submitEncryptionDemoEpic)
